/**
 * The resort plan — a drawing, not a survey.
 *
 * This used to live inside MapPage and the two thumbnail slots showed a
 * generated gradient instead, which read as a photograph of a venue nobody had
 * photographed. The plan is the honest thing to show in both places: it is the
 * same drawing the map uses, and with `focus` set it points at the one venue
 * being talked about.
 */

interface Props {
  className?: string;
  /** Percentage coordinates of the venue to mark, if any. */
  focus?: { x: number; y: number };
  label?: string;
}

export default function ResortPlan({ className = 'map-plan', focus, label = 'Resort site plan' }: Props) {
  return (
    <svg className={className} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" aria-label={label}>
      <rect width="100" height="100" fill="var(--color-neutral-200)" />
      <path d="M0 74 Q 30 82 55 92 T 100 100 L 0 100 Z" fill="var(--color-accent-2-200)" opacity="0.5" />
      <path d="M0 86 Q 34 92 62 99 T 100 104 L 0 104 Z" fill="var(--color-accent-300)" opacity="0.45" />
      <ellipse cx="50" cy="66" rx="11" ry="5" fill="var(--color-accent-2-300)" opacity="0.7" />
      <g fill="var(--color-neutral-300)" stroke="var(--color-neutral-400)" strokeWidth="0.4">
        <rect x="38" y="38" width="16" height="12" rx="1.5" />
        <rect x="24" y="56" width="12" height="8" rx="1.5" />
        <rect x="64" y="34" width="12" height="9" rx="1.5" />
        <rect x="52" y="12" width="12" height="8" rx="1.5" />
      </g>
      <g stroke="var(--color-neutral-400)" strokeWidth="0.7" strokeDasharray="2 2" fill="none" opacity="0.8">
        <path d="M46 50 L 46 62 L 30 62 M46 62 L 50 68 M54 44 L 70 40 M58 20 L 52 34 L 46 38" />
      </g>
      {focus && (
        <>
          <circle cx={focus.x} cy={focus.y} r="11" fill="var(--color-accent-600)" opacity="0.18" />
          <circle cx={focus.x} cy={focus.y} r="4.5" fill="var(--color-accent-600)" stroke="var(--color-bg)" strokeWidth="1.6" />
        </>
      )}
    </svg>
  );
}
